// extracted by mini-css-extract-plugin
export default {"root":"time-picker_root__Tgd5j"};